import { SideNavLayout } from 'ia-react-core';
import React, { FC, ReactNode, useCallback, useContext, useMemo } from 'react';
import { ThemeContext } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ApplicationLayoutProps } from 'omni-package-react-core';

export interface ErrorLayoutProps extends ApplicationLayoutProps {
  children: ReactNode;
  preventLogoClick?: boolean;
}

const ErrorLayout: FC<ErrorLayoutProps> = ({ children, preventLogoClick }) => {
  const theme = useContext(ThemeContext);
  const { t } = useTranslation('App');

  const bg = useMemo(() => theme.colors.gbiBlueHaze, [theme.colors.gbiBlueHaze]);

  const handleMainLogoClick = useCallback((event: React.MouseEvent) => {
    if (preventLogoClick) {
      event.preventDefault();
    }
  }, [preventLogoClick]);

  return (
    <SideNavLayout
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      appName={t('mainHeader.ClientSpace').toUpperCase()}
      p-t={28}
      fullContentHeight
      contentBackground={bg}
      sideNavVisible={false}
      maxContentWidth={1136}
      languageButtonInlineWithSlogan
      onMainLogoClick={handleMainLogoClick}
    >
      {children}
    </SideNavLayout>
  );
};
export default ErrorLayout;
